import type { i18n } from 'i18next';

import { questionScopeCategories } from '/business/shared/util/Statics';
import initiativeCardBackground from '/business/shared/images/initiatives/Electricity-card-1x.jpg';
import initiativeBackground from '/business/shared/images/initiatives/Electricity-card-2x.jpg';

import BoltIcon from '/business/shared/images/icons/icon-electricity-bolt.svg';

import ElectricityHeatSteamSelection from '/business/shared/components/questions/scope2/electricityHeatSteam/ElectricityHeatSteamSelection';
import { BottomHeatSteamLandingPage } from '/business/shared/components/questions/scope2/_education/BottomHeatSteamLandingPage';
import { BottomLocationsPage } from '/business/shared/components/questions/scope2/_education/BottomLocationsPage';
import { BottomCertsPage } from '/business/shared/components/questions/scope2/_education/BottomCertsPage';
import { BottomConsumptionPage } from '/business/shared/components/questions/scope2/_education/BottomConsumptionPage';

import HeatSteamLanding from '/business/shared/components/questions/scope2/_education/heat-steam-landing';
import HeatSteamLocations from '/business/shared/components/questions/scope2/_education/heat-steam-locations';
import HeatSteamCerts from '/business/shared/components/questions/scope2/_education/heat-steam-certificates';
import HeatSteamConsumption from '/business/shared/components/questions/scope2/_education/heat-steam-consumption';

import ElectricityHeatSteamCerts from '/business/shared/components/questions/scope2/electricityHeatSteam/ElectricityHeatSteamCerts';
import ElectricityHeatSteamLocations from '/business/shared/components/questions/scope2/electricityHeatSteam/ElectricityHeatSteamLocations';
import ElectricityHeatSteamConsumption from '/business/shared/components/questions/scope2/electricityHeatSteam/ElectricityHeatSteamConsumption';
import ElectricityHeatSteamConsumptionAdd from '/business/shared/components/questions/scope2/electricityHeatSteam/ElectricityHeatSteamConsumptionAdd';
import ElectricityHeatSteamLocationsAdd from '/business/shared/components/questions/scope2/electricityHeatSteam/ElectricityHeatSteamLocationsAdd';
import ElectricityHeatSteamCertsAdd from '/business/shared/components/questions/scope2/electricityHeatSteam/ElectricityHeatSteamCertsAdd';

interface Props {
  i18n: i18n;
}

export const getConfigureElectricityHeatSteam = (_: Props) => {
  return {
    splitQuestions: true,
    scopeCategory: questionScopeCategories.SCOPE_2,
    id: 'electricity-heat-steam',
    hideSidebar: true,
    removeProvidedPadding: true,
    isCompletePropName: 'electricity-heat-steam',
    primaryI18nKey: 'business:QuestionPage.forms.emissionSelector.electricityHeatSteam',
    subTextI18nKey: 'business:QuestionPage.forms.emissionSelector.electricityHeatSteamTip',
    overviewPageTitleI18nKey: 'business:QuestionPage.forms.emissionSelector.electricityHeatSteam',
    title: 'Electricity, heat and steam',
    isSelectorPage: true,

    icon: BoltIcon,
    selector: {
      injectQuestionBranchSelector: false,
    },
    form: ElectricityHeatSteamSelection,
    subQuestions: [
      {
        id: 'calc-elect-consumption-flag-elect',
        apiKey: 'calc-elect-consumption-flag-elect',
        title: 'Electricity',
        initiative: {
          getVisuals: () => {
            return {
              description: false,
              background: initiativeBackground,
              useMask: false,
              cardBackground: initiativeCardBackground,
            };
          },
          formatForInitiativeSummary: () => {
            return {
              isShowingReportingPeriod: false,
              isShowingReportingPeriodNoReduction: true,
              category: false,
              description:
                'Electricity consumption to reduce  after incorporating the initiatives already added to the plan so far',
              descriptionNoReduction: 'Non renewable electricity consumption during the reporting period ',
            };
          },
        },
      },
      {
        id: 'calc-elect-consumption-flag-heat',
        apiKey: 'calc-elect-consumption-flag-heat',
        title: 'Heat',
        initiative: {
          getVisuals: () => {
            return {
              description: false,
              background: initiativeBackground,
              useMask: false,
              cardBackground: initiativeCardBackground,
            };
          },
          formatForInitiativeSummary: () => {
            return {
              isShowingReportingPeriod: false,
              isShowingReportingPeriodNoReduction: true,
              category: false,
              description:
                'Heat consumption to reduce after incorporating the initiatives already added to the plan so far',
              descriptionNoReduction: 'Heat consumption during the reporting period ',
            };
          },
        },
      },
      {
        id: 'calc-elect-consumption-flag-steam',
        apiKey: 'calc-elect-consumption-flag-steam',
        title: 'Steam',
        initiative: {
          getVisuals: () => {
            return {
              description: false,
              background: initiativeBackground,
              useMask: false,
              cardBackground: initiativeCardBackground,
            };
          },
          formatForInitiativeSummary: () => {
            return {
              isShowingReportingPeriod: false,
              isShowingReportingPeriodNoReduction: true,
              category: false,
              description:
                'Steam consumption to reduce after incorporating the initiatives already added to the plan so far',
              descriptionNoReduction: 'Steam consumption during the reporting period ',
            };
          },
        },
      },

      {
        isSelectorPage: true,
        id: 'locations',
        hideSidebar: true,
        removeProvidedPadding: true,
        form: ElectricityHeatSteamLocations,
        education: {
          hasEducationWidget: true,
          bottomContentsActivity: BottomLocationsPage,
          educationContent: () => {
            return HeatSteamLocations;
          },
        },
        subQuestions: [
          {
            id: 'locations-add',
            breadcrumbTitle: 'Add a new location',
            editModeBreadcrumbTitle: 'Edit location',
            isSelectorPage: true,
            hideSidebar: true,
            enforceSidebarSpace: true,
            removeProvidedPadding: true,
            form: ElectricityHeatSteamLocationsAdd,
            education: {
              hasEducationWidget: true,
              bottomContentsActivity: BottomLocationsPage,
              educationContent: () => {
                return HeatSteamLocations;
              },
            },
          },
        ],
      },
      {
        id: 'consumption-data',
        hideSidebar: true,
        removeProvidedPadding: true,
        isSelectorPage: true,
        education: {
          hasEducationWidget: true,
          bottomContentsActivity: BottomConsumptionPage,
          educationContent: () => {
            return HeatSteamConsumption;
          },
        },
        form: ElectricityHeatSteamConsumption,
        subQuestions: [
          {
            id: 'consumption-data-add',
            breadcrumbTitle: 'Add new consumption data',
            editModeBreadcrumbTitle: 'Edit consumption data',
            isSelectorPage: true,
            hideSidebar: true,
            enforceSidebarSpace: true,
            education: {
              hasEducationWidget: true,
              bottomContentsActivity: BottomConsumptionPage,
              educationContent: () => {
                return HeatSteamConsumption;
              },
            },
            removeProvidedPadding: true,
            form: ElectricityHeatSteamConsumptionAdd,
          },
        ],
      },
      {
        id: 'energy-attribute-certificates',
        isSelectorPage: true,
        hideSidebar: true,
        education: {
          hasEducationWidget: true,
          bottomContentsActivity: BottomCertsPage,
          educationContent: () => {
            return HeatSteamCerts;
          },
        },
        removeProvidedPadding: true,
        form: ElectricityHeatSteamCerts,
        subQuestions: [
          {
            id: 'energy-attribute-certificates-add',
            breadcrumbTitle: 'Add new energy attribute certificates',
            editModeBreadcrumbTitle: 'Edit energy attribute certificate',
            hideSidebar: true,
            enforceSidebarSpace: true,
            removeProvidedPadding: true,
            isSelectorPage: true,
            education: {
              hasEducationWidget: true,
              bottomContentsActivity: BottomCertsPage,
              educationContent: () => {
                return HeatSteamCerts;
              },
            },
            form: ElectricityHeatSteamCertsAdd,
          },
        ],
      },
    ],
    education: {
      hasEducationWidget: true,
      bottomContentsActivity: BottomHeatSteamLandingPage,
      educationContent: () => {
        return HeatSteamLanding;
      },
    },
  };
};
